import { FETCH_CUTTING_DC_SUCCESS } from "../../CuttingDc/cuttingDC/cuttingDC.actionsType";
import { CREATE_USER_FORM_CUSTOMER_PO, CUSTOMER_PO_USERFORM_RESET, FETCH_CUSTOMER_PO_DELIVERY_AT_FAILURE, FETCH_CUSTOMER_PO_DELIVERY_AT_REQUEST, FETCH_CUSTOMER_PO_DELIVERY_AT_SUCCESS, FETCH_CUSTOMER_PO_FAILURE, FETCH_CUSTOMER_PO_INVOICE_FAILURE, FETCH_CUSTOMER_PO_INVOICE_REQUEST, FETCH_CUSTOMER_PO_INVOICE_SUCCESS, FETCH_CUSTOMER_PO_REQUEST, FETCH_CUSTOMER_PO_SUCCESS, FETCH_SINGLE_CUSTOMER_PO_FAILURE, FETCH_SINGLE_CUSTOMER_PO_REQUEST, FETCH_SINGLE_CUSTOMER_PO_SUCCESS, HEADER_SEARCH_CALL_ONLOAD, NAVIGATE_CUSTOMER_PO, NAVIGATE_CUSTOMER_PO_DETAILS, RESET_CUSTOMER_PO_INVOICE, TAB_ACTIVE_KEY } from "./customerPO.actionsType";

export const CUSTOMER_PO = 'customerPO';


let initialState = {
    loading: false,
    activeKey: '1',
    isCustomerPO: false,
    userform: {
        fldFKCustomerID: '',
        fldFKDeliveryTo: '',
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: '1',

    },
    customerId: [],
    customerDeliveryId: [],
    headerSearchCall: true,
    customerPOSelectedValue: {},
    customerPOInvoice: [],
    headerActiveKey: 1
};

export let customerPOReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;


    switch (type) {
        case FETCH_CUSTOMER_PO_REQUEST:
        case FETCH_CUSTOMER_PO_DELIVERY_AT_REQUEST:
        case FETCH_SINGLE_CUSTOMER_PO_REQUEST:
        case FETCH_CUSTOMER_PO_INVOICE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_USER_FORM_CUSTOMER_PO:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case TAB_ACTIVE_KEY:
            return {
                ...state,
                activeKey: payload

            }
        case FETCH_CUSTOMER_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                customerId: updatePayload
            };
        case FETCH_CUSTOMER_PO_DELIVERY_AT_SUCCESS:
            return {
                ...state,
                loading: false,
                customerDeliveryId: updatePayload
            };
        case FETCH_CUSTOMER_PO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                customerPOInvoice: updatePayload
            };

        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                loading: false,
                ...state,
                headerSearchCall: payload
            }
        case FETCH_SINGLE_CUSTOMER_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }

            };
        case FETCH_CUSTOMER_PO_FAILURE:
        case FETCH_CUSTOMER_PO_DELIVERY_AT_FAILURE:
        case FETCH_SINGLE_CUSTOMER_PO_FAILURE:
        case FETCH_CUSTOMER_PO_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CUSTOMER_PO_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryTo: '',
                    fldFKCustomerID: '',
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
            };
        case NAVIGATE_CUSTOMER_PO_DETAILS:
            return {
                ...state,
                isCustomerPO: true,
                loading: false,
                customerPOSelectedValue: updatePayload.customerPOSelectedValue
            };
        case NAVIGATE_CUSTOMER_PO:
            return {
                ...state,
                isCustomerPO: false,
            };
        case RESET_CUSTOMER_PO_INVOICE:
            return {
                ...state,
                customerPOInvoice: [],
            };
        default:
            return state;
    }
}